<template>
	<transition
			appear
			:appear-active-class="$_trnMdlShtLyt_stylePageLayoutAnimation()">
		<template v-if="initialized_">
			<v-row class="customVRow" no-gutters>
				<v-col>
					<!-- training summary -->
					<v-row	justify="center">
						<v-col cols="11" md="9">
							<v-sheet
									class="customVSheet"
									:color="$_trnMdlShtLyt_styleModuleSheetBodySheetColor"
									:dark="$_trnMdlShtLyt_styleModuleSheetBodySheetDark"
									:elevation="$_trnMdlShtLyt_styleModuleSheetBodySheetElevation"
									:light="$_trnMdlShtLyt_styleModuleSheetBodySheetLight">
								<v-card	class="customVCard"
										color="transparent"
										flat>
									<!-- big image -->
									<template v-if="isObject($_trnMdlShtLyt_styleTrainingBigImage)">
										<v-row>
											<v-col>
												<v-img	class="customVImg"
														:src="$_trnMdlShtLyt_styleTrainingBigImageUrl" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<!-- image -->
										<template v-if="isObject($_trnMdlShtLyt_styleTrainingImage)">
											<v-col cols="12" md="4" class="center">
												<v-img	class="customVImg"
														:src="$_trnMdlShtLyt_styleTrainingImageUrl" />
											</v-col>
										</template>
										<v-col>
											<!-- title -->
											<v-row no-gutters>
												<v-col>
													<v-card-title>
														<span v-html="$_trnMdlShtLyt_langTrainingTitle" />
													</v-card-title>
												</v-col>
											</v-row>
											<!-- text -->
											<template v-if="!isFalse($_trnMdlShtLyt_langTrainingText)">
												<v-row no-gutters>
													<v-col>
														<v-card-text>
															<span	class="caption markdown"
																	v-html="marked($_trnMdlShtLyt_langTrainingText)" />
														</v-card-text>
													</v-col>
												</v-row>
											</template>
										</v-col>
									</v-row>
								</v-card>
							</v-sheet>
						</v-col>
					</v-row>
					<!-- training modules -->
					<template v-for="(moduleVals, moduleKey) in sortObject($_trnMdlShtLyt_stateTrainingsCourseModules, 'order')">
						<v-row	:key="moduleKey"
								class="row_"
								no-gutters>
							<v-col>
								<!-- title -->
								<v-row justify="center">
									<v-col cols="11" md="9">
										<v-sheet
												class="customVSheet"
												:color="$_trnMdlShtLyt_styleModuleSheetBodySheetColor"
												:dark="$_trnMdlShtLyt_styleModuleSheetBodySheetDark"
												:elevation="$_trnMdlShtLyt_styleModuleSheetBodySheetElevation"
												:light="$_trnMdlShtLyt_styleModuleSheetBodySheetLight">
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<v-row>
													<!-- image -->
													<template v-if="isObject(moduleVals.image)">
														<v-col cols="12" md="4" class="center">
															<v-img	class="customVImg"
																	:src="$_trnMdlShtLyt_styleContentImageUrl(moduleVals)" />
														</v-col>
													</template>
													<v-col>
														<!-- title -->
														<template v-if="moduleVals.title">
															<v-row no-gutters>
																<v-col>
																	<v-card-title>
																		<span v-html="$_trnMdlShtLyt_langContentTitle(moduleVals)" />
																	</v-card-title>
																</v-col>
															</v-row>
														</template>
														<!-- text -->
														<template v-if="!isFalse($_trnMdlShtLyt_langContentText(moduleVals))">
															<v-row no-gutters>
																<v-col>
																	<v-card-text>
																		<span	class="markdown"
																				v-html="marked($_trnMdlShtLyt_langContentText(moduleVals))" />
																	</v-card-text>
																</v-col>
															</v-row>
														</template>
														<!-- action buttons -->
														<template v-if="moduleVals.actionButtons">
															<v-row no-gutters>
																<v-col>
																	<v-card-actions>
																		<v-row dense>
																			<template v-for="(actionButtonVals, actionButtonKey) in sortObject(moduleVals.actionButtons, 'order')">
																				<v-col :key="actionButtonKey">
																					<v-btn	class="customVBtn"
																							:block="$_trnMdlShtLyt_styleModuleSheetActionButtonBlock"
																							:color="$_trnMdlShtLyt_styleModuleSheetActionButtonColor"
																							:dark="$_trnMdlShtLyt_styleModuleSheetActionButtonDark"
																							:depressed="$_trnMdlShtLyt_styleModuleSheetActionButtonDepressed"
																							:elevation="$_trnMdlShtLyt_styleModuleSheetActionButtonElevation"
																							:large="$_trnMdlShtLyt_styleModuleSheetActionButtonLarge"
																							:light="$_trnMdlShtLyt_styleModuleSheetActionButtonLight"
																							:outlined="$_trnMdlShtLyt_styleModuleSheetActionButtonOutlined"
																							:rounded="$_trnMdlShtLyt_styleModuleSheetActionButtonRounded"
																							:small="$_trnMdlShtLyt_styleModuleSheetActionButtonSmall"
																							:text="$_trnMdlShtLyt_styleModuleSheetActionButtonFlat"
																							@click="openLink(actionButtonVals.link)"
																							v-text="$_trnMdlShtLyt_langActionButtonTitle(actionButtonVals)" />
																				</v-col>
																			</template>
																		</v-row>
																	</v-card-actions>
																</v-col>
															</v-row>
														</template>
														<!-- open module button -->
														<v-row no-gutters>
															<v-col>
																<v-card-actions>
																	<v-row dense>
																		<v-col cols="auto">
																			<v-btn	class="customVBtn"

																					:disabled="!$_trnMdlShtLyt_checkModuleStatus(moduleKey) || ($_trnMdlShtLyt_stateTrainingsCourseIsSequentialCourse && !$_trnMdlShtLyt_checkPreviousModuleStatus(moduleKey, 'finished'))"

																					:block="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonBlock"
																					:color="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonColor"
																					:dark="!$_trnMdlShtLyt_checkModuleStatus(moduleKey) || ($_trnMdlShtLyt_stateTrainingsCourseIsSequentialCourse && !$_trnMdlShtLyt_checkPreviousModuleStatus(moduleKey, 'finished')) ? false : $_trnMdlShtLyt_styleModuleSheetOpenModuleButtonDark"
																					:depressed="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonDepressed"
																					:elevation="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonElevation"
																					:large="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonLarge"
																					:light="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonLight"
																					:outlined="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonOutlined"
																					:rounded="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonRounded"
																					:small="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonSmall"
																					:text="$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonFlat"
																					@click="$_trnMdlShtLyt_startModule(moduleKey)"
																					v-text="$_trnMdlShtLyt_langModuleSheetOpenModule" />
																		</v-col>
																	</v-row>
																</v-card-actions>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-card>
										</v-sheet>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</v-col>
			</v-row>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'TrainingModuleSheetLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				initialized_: false
			}
		},
		computed: {
			// params
			$_trnMdlShtLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_trnMdlShtLyt_paramsCourseCode() {
				const self_ = this;
				const params_ = self_.$_trnMdlShtLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.courseCode
			},
			// current user
			$_trnMdlShtLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_trnMdlShtLyt_stateTrainingsCourse() {
				const self_ = this;
				const courseCode_ = self_.$_trnMdlShtLyt_paramsCourseCode;
				if(self_.isFalse(courseCode_)) { return }
				return self_.getTrainingsState(courseCode_)
			},
			$_trnMdlShtLyt_stateTrainingsCourseIsGroupCourse() {
				const self_ = this;
				const course_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(course_)) { return null }
				return course_.isGroupCourse
			},
			$_trnMdlShtLyt_stateTrainingsCourseIsSequentialCourse() {
				const self_ = this;
				const course_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(course_)) { return null }
				return course_.isSequentialCourse
			},
			$_trnMdlShtLyt_stateTrainingsCourseModules() {
				const self_ = this;
				const course_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(course_)) { return {} }
				return course_.modules
			},
			// lang
			$_trnMdlShtLyt_langModuleSheetOpenModule() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'moduleSheetOpenModule')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_trnMdlShtLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const title_ = contentVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_trnMdlShtLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const text_ = contentVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			// (action buttons)
			$_trnMdlShtLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					if(self_.isFalse(actionButtonVals.title)) { return null }
					return self_.getLangsVal(actionButtonVals.title)
				}
			},
			// style
			$_trnMdlShtLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_trnMdlShtLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_trnMdlShtLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_trnMdlShtLyt_styleModuleSheetHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'moduleSheetHeaderSheet')
			},
			$_trnMdlShtLyt_styleModuleSheetHeaderSheetColor() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_trnMdlShtLyt_styleModuleSheetHeaderSheetDark() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_trnMdlShtLyt_styleModuleSheetHeaderSheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_trnMdlShtLyt_styleModuleSheetHeaderSheetLight() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_trnMdlShtLyt_styleModuleSheetBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'moduleSheetBodySheet')
			},
			$_trnMdlShtLyt_styleModuleSheetBodySheetColor() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_trnMdlShtLyt_styleModuleSheetBodySheetDark() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_trnMdlShtLyt_styleModuleSheetBodySheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_trnMdlShtLyt_styleModuleSheetBodySheetLight() {
				const self_ = this;
				const sheet_ = self_.$_trnMdlShtLyt_styleModuleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'moduleSheetActionButton')
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_trnMdlShtLyt_styleModuleSheetActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'moduleSheetOpenModuleButton')
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_trnMdlShtLyt_styleModuleSheetOpenModuleButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_trnMdlShtLyt_styleModuleSheetOpenModuleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_trnMdlShtLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_trnMdlShtLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_trnMdlShtLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_trnMdlShtLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_trnMdlShtLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const bigImage_ = self_.$_trnMdlShtLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(bigImage_)) { return null }
					return self_.getStylesVal(bigImage_.url)
				}
			},
			// (training)
			$_trnMdlShtLyt_langTrainingTitle() {
				const self_ = this;
				const training_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(training_)) { return null }
				return self_.getLangsVal(training_.title)
			},
			$_trnMdlShtLyt_langTrainingText() {
				const self_ = this;
				const training_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(training_)) { return null }
				return self_.getLangsVal(training_.text)
			},
			$_trnMdlShtLyt_styleTrainingImage() {
				const self_ = this;
				const training_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(training_)) { return null }
				return training_.image
			},
			$_trnMdlShtLyt_styleTrainingImageUrl() {
				const self_ = this;
				const image_ = self_.$_trnMdlShtLyt_styleTrainingImage;
				if(self_.isEmpty(image_)) { return null }
				return self_.getStylesVal(image_.url)
			},
			$_trnMdlShtLyt_styleTrainingBigImage() {
				const self_ = this;
				const training_ = self_.$_trnMdlShtLyt_stateTrainingsCourse;
				if(self_.isEmpty(training_)) { return null }
				return training_.bigImage
			},
			$_trnMdlShtLyt_styleTrainingBigImageUrl() {
				const self_ = this;
				const bigImage_ = self_.$_trnMdlShtLyt_styleTrainingBigImage
				if(self_.isEmpty(bigImage_)) { return null }
				return self_.getStylesVal(bigImage_.url)
			}
		},
		created() {
			const self_ = this;
			self_.$_trnMdlShtLyt_initialize()
		},
		methods: {
			$_trnMdlShtLyt_initialize() {
				const self_ = this;

				self_.initialized_ = false; 

				const uid_ = self_.$_trnMdlShtLyt_currentUserUid;
				const courseCode_ = self_.$_trnMdlShtLyt_paramsCourseCode;

				Promise.resolve().then(() => {
					return self_.initializeTrainings(courseCode_)
				}).then(() => {
					return self_.initializeUser('trainingData')
				}).then(() => {
					const status_ = self_.getUserTrainingStatus(uid_, courseCode_, null, null)

					if(self_.isFalse(status_) || status_ == 'closed') { self_.$_trnMdlShtLyt_backToTraining() }

					self_.initialized_ = true; 
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnMdlShtLyt_initialize()', error)
				})
			},
			$_trnMdlShtLyt_checkModuleStatus(moduleCode) {
				const self_ = this;

				const uid_ = self_.$_trnMdlShtLyt_currentUserUid;
				const courseCode_ = self_.$_trnMdlShtLyt_paramsCourseCode;

				const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode, null)

				let result_ = false;

				if(status_ == 'opened' || status_ == 'started' || status_ == 'finished') { result_ = true }

				return result_
			},
			$_trnMdlShtLyt_checkPreviousModuleStatus(moduleCode, status) {
				const self_ = this;

				const uid_ = self_.$_trnMdlShtLyt_currentUserUid;
				const courseCode_ = self_.$_trnMdlShtLyt_paramsCourseCode;

				const previousModuleCode_ = self_.getPreviousModuleCode(courseCode_, moduleCode)

				if(self_.isFalse(previousModuleCode_)) { return true } // first module

				const status_ = self_.getUserTrainingStatus(uid_, courseCode_, previousModuleCode_, null)

				let result_ = false;

				if(self_.isFalse(status)) {
					if(status_ == 'opened' || status_ == 'started' || status_ == 'finished') { result_ = true }
				} else {
					if(status_ == status) { result_ = true }
				}

				return result_
			},
			$_trnMdlShtLyt_startModule(moduleCode) {
				const self_ = this;
				const router_ = self_.$router;

				const uid_ = self_.$_trnMdlShtLyt_currentUserUid;
				const courseCode_ = self_.$_trnMdlShtLyt_paramsCourseCode;

				Promise.resolve().then(() => {
					const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode, null)

					if(status_ == 'opened') {
						self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode, null, 'started')
					} else {
						return Promise.resolve()
					}
				})
				// open
				const to_ = {
					name: 'training',
					params: {
						courseCode: self_.$_trnMdlShtLyt_paramsCourseCode,
						moduleCode: moduleCode
					}
				}
				router_.push(to_)
			},
			$_trnMdlShtLyt_backToTraining() {
				const self_ = this;
				self_.openLink({ to: '/training' })				
			}
		}
	}
</script>

<style scoped>
	.pretty_ {
		border: none;
		color: #ff5252;
	}
	.row_ {
		margin-top: 12px
	}
</style>